const Heading = ({ text, wrapperClassNames = "", title = true }) => {
  return (
    <header
      className={`heading h2 ${
        title ? "primary-color" : ""
      } ${wrapperClassNames}`}
    >
      {text}
    </header>
  );
};

export default Heading;
